"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.Attachment = exports.TemplatedMessage = exports.Message = exports.Errors = exports.Models = exports.AdminClient = exports.AccountClient = exports.Client = exports.ServerClient = void 0;
var AccountClient_1 = require("./client/AccountClient");
exports.AccountClient = AccountClient_1.default;
exports.AdminClient = AccountClient_1.default;
var ServerClient_1 = require("./client/ServerClient");
exports.ServerClient = ServerClient_1.default;
exports.Client = ServerClient_1.default;
var Models = require("./client/models");
exports.Models = Models;
var Errors = require("./client/errors/Errors");
exports.Errors = Errors;
// Essential types are exposed directly
// to make working with common requests simpler.
var models_1 = require("./client/models");
Object.defineProperty(exports, "Message", { enumerable: true, get: function () { return models_1.Message; } });
var models_2 = require("./client/models");
Object.defineProperty(exports, "TemplatedMessage", { enumerable: true, get: function () { return models_2.TemplatedMessage; } });
var models_3 = require("./client/models");
Object.defineProperty(exports, "Attachment", { enumerable: true, get: function () { return models_3.Attachment; } });
var models_4 = require("./client/models");
Object.defineProperty(exports, "Header", { enumerable: true, get: function () { return models_4.Header; } });
//# sourceMappingURL=index.js.map